import { Component } from '@angular/core';

@Component({
    selector: 'app-interaction-report',
    imports: [],
    templateUrl: './interaction-report.component.html',
    styleUrl: './interaction-report.component.scss'
})
export class InteractionReportComponent {

}
